import React from 'react'
import PropTypes from 'prop-types'


import './style.scss'

const DEFAULT_IMAGE = require('img/users/notUser.gif')


export default function SelectedClient(props) {
  const fullName = `${props.client.user.first_name} ${props.client.user.last_name}`
  const picture = props.client.user.picture || DEFAULT_IMAGE
  const activeClass = props.client.user.is_active ? 'active' : 'inactive'

  return (
    <div key={props.client.id} className="DriversForm__clients--item">
      <div className="DriversForm__clients--item-data">
        <div className="DriversForm__clients--item-data__photo">
          <div
            className="img"
            style={{backgroundImage: `url(${picture})`}}>
          </div>
          <div className={`dot ${activeClass}`}>
          </div>
        </div>
        <div>
          <p>{fullName}</p>
          <p>{props.client.user.email}</p>
        </div>
      </div>
      <button onClick={props.onDelete}>
        <i className="material-icons">delete_forever</i>
      </button>
    </div>
  )
}

SelectedClient.propTypes = {
  client: PropTypes.object.isRequired,
  onDelete: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/components/DriversForm/SelectedClient/index.js